import { purchaseMode } from "@/features/payment/shopPurchaseService";
import type { PurchaseGateConfig } from "@/features/payment/purchaseGate";

function readBoolEnv(raw: string | undefined, fallback: boolean): boolean {
  if (raw === "true" || raw === "1") return true;
  if (raw === "false" || raw === "0") return false;
  return fallback;
}

export function resolvePurchaseGateConfig(): PurchaseGateConfig {
  return {
    recommendSignInForAnonymous: readBoolEnv(
      import.meta.env.VITE_PURCHASE_GATE_RECOMMEND_ANON,
      true,
    ),
    applyInDevFreeMode: readBoolEnv(
      import.meta.env.VITE_PURCHASE_GATE_DEV_FREE,
      false,
    ),
    purchaseMode,
  };
}
